import React from 'react'
import { LoginHeader } from './Components/Auth/LoginHeader'
import { LoginForm } from './Components/Auth/LoginForm'
import { LoginSidebar } from './Components/Auth/LoginSidebar'
import { useAuth } from './Hooks/useAuth'
import logoImg from '../../assets/logo-login.png'
import logoText from '../../assets/Ai_text_logo.png'

export default function LoginPage() {
  const { login, loading, error } = useAuth()

  const handleLogin = async (formData) => {
    await login(formData)
  }

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gray-50">
      {/* Left side - Form */}
      <div className="w-full md:w-1/2 flex flex-col justify-center items-center p-4 sm:p-6 min-h-[100dvh] md:min-h-0">
        <LoginHeader logoImg={logoImg} logoText={logoText} />
        <LoginForm 
          onSubmit={handleLogin}
          loading={loading}
          error={error}
        />
      </div>

      {/* Right side - Image */}
      <LoginSidebar />
    </div>
  )
}